import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "font-awesome/css/font-awesome.min.css";
import "../SalesLanding/Assets/css/_fonts/_open_sans.css";

import * as React from "react";
import { useEffect,useState } from "react";
import { Route, useLocation } from "react-router-dom";
import Header from "../SalesLanding/components/Header";
import PageFooter from "../components/PageFooter";
//import PageFooter from "../SalesLanding/components/Footer";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../store";
import * as TestimonialsActions from "../store/salesLandingStore/testimonials/action";
import * as httpClient from "../util/httpClient";

interface IDefaultProps {
    component: any;
    path?: string;
    exact?: boolean;
}

const SalesLandingLayout: React.SFC<IDefaultProps> = (props) => {
    const search = useLocation().search;
    const offerName = new URLSearchParams(search).get("offerCode");
    const retailerCode = new URLSearchParams(search).get("RetailerCode");
    const dispatch = useDispatch();
    const [value, setValue] = useState(false);
    const partnerDisplayName: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName
            ? state.configurationState.configuration.partnerConfig.partnerDisplayName
            : ""
    );
    const isPartnerConfigDataLoading: boolean = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.isPartnerConfigDataLoading
            ? state.configurationState.isPartnerConfigDataLoading
            : false
    );
    // Removing Padding from body on SalesLanding Page
    let currentPathLoc = useLocation();
   
    const { component: Component, ...rest } = props;
    useEffect(() => {
        var currentPath = currentPathLoc.pathname.slice(1);
        currentPath = currentPath.replace("/", " | ");
        currentPath = currentPath.split("-").join(" ");
        currentPath = currentPath.replace(/(?:^|\s)\S/g, (res) => {
            return res.toUpperCase();
        });
        if (currentPath.toLowerCase().includes("sales_landing") === true) {
            document.body.style.paddingTop = "0";

            document.addEventListener("visibilitychange", function (e) {
                var isPageActive = !document.hidden;

                if (currentPath.toLowerCase().includes("step3") === true) {
                    document.title = partnerDisplayName + " | Register";
                }

                if (currentPath.toLowerCase().includes("step3") === false) {
                    if (!isPageActive) {
                        document.title = "Get Protected Today!";
                    } else {
                        document.title = "Get Protected | " + partnerDisplayName; // + '®'
                    }
                }
            });
        }
    }, [currentPathLoc]);

    useEffect(() => {
        if (props.path === "/sales_landing/step2") {
            let requestBody = {
                retailerCode: retailerCode,
                offerCode: offerName,
            };
            httpClient.sendRequest("POST", "web/funnel/Get-Funnel-Package-Matrix", requestBody)
                .then((data: any) => {
                    if (data && data?.packageDetails) {
                        let sampleArray: any = [];
                        let found: boolean = false;
                        let promotionalText: string = data?.promotionalBannerText ? data.promotionalBannerText.trim() : "";
                        dispatch(TestimonialsActions.actionCreators.getPromoMessage(promotionalText));
                        data.packageDetails.length > 0 &&
                            data.packageDetails.forEach((item: any) => {
                                sampleArray.push(item.trialDetails.isTrial);
                                item?.packages?.forEach((obj: any) => {
                                    if (!found) {
                                        found = obj.packageServiceslst.some((service: any) => service.serviceName === "Unlimited children monitored under 18");
                                        data.serviceFound = found;
                                    }
                                });
                            });
                        if (sampleArray.includes(true)) {
                            data.isPlannerNeedHeight = true;
                        }
                    }
                    dispatch(TestimonialsActions.actionCreators.getPackageMatrix(data));
                    setValue(true);
                })
                .catch(() => {
                    setValue(true)
                });
        }
    }, [])
    
    if (props.path === "/sales_landing/step2" && !value) {
        return (<div className="loading">
        </div>);
    }
    
    return (
        <Route
            {...rest}
            render={(matchProps) => (
                <React.Fragment>
                    {isPartnerConfigDataLoading ?
                        <div className="sales-landing">
                            <Header />
                            <Component {...matchProps} />
                            <PageFooter />
                        </div> : <div className="loading">
                        </div>}
                </React.Fragment>
            )}
        />
    );
};

export default SalesLandingLayout;
